<template>
  <div class="table-view-cell w-full">
    <div class="flex justify-between items-start p-4">
      <div class="flex-grow">
        <slot />
      </div>
      <template v-if="contextMenuItems && contextMenuItems.length">
        <bdg-button
          class="ghost no-min-width uppercase"
          @click.native="contextMenuItems[0].clickAction"
          v-if="contextMenuItems.length === 1"
        >
          {{ contextMenuItems[0].name }}
        </bdg-button>
        <context-menu
          class="ml-2"
          :context-menu-items="contextMenuItems"
          v-else
        />
      </template>
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
import ContextMenu from "../../ContextMenu";
import BdgButton from "../../BdgButton";

export default {
  name: "ListViewCell",
  components: { BdgButton, ContextMenu },
  props: {
    contextMenuItems: Array
  }
};
</script>

<style lang="scss" scoped>
.table-view-cell {
  @apply w-full;

  &:nth-child(even) {
    @apply bg-lightgray-lightest;
  }
}
</style>
